var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"button"},[_c('v-col',[_c('v-btn',{attrs:{"large":"","color":"primary","min-width":"200","elevation":"2","to":_vm.url}},[_vm._v(" ＞＞"+_vm._s(_vm.buttonText)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }